import React from "react";  
import "./footer.css"

const Footer = () => {
    return (
    
    <div className="footer">
       
    </div>
    )
}

export default Footer;